import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/landing/Navbar';
import Footer from '../components/common/Footer';

const AboutProgramPage = () => {
  const location = useLocation();

  useEffect(() => {
    // Verifică dacă URL-ul conține un hash și navigheaza la ancora respectivă
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return (
    <div id="about-program" className="bg-gray-50 min-h-screen">
      {/* Navigation Bar */}
      <Navbar />
      
      {/* Main Content */}
      <div className="container mx-auto px-4 py-12 mt-24">
        <h1 className="text-4xl font-bold text-gray-800 mb-6 text-center">Despre Start-Up Nation 2025 – 2026, Ediția a 2-a</h1>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl p-8 shadow-sm mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Ce este Start-Up Nation 2025 – 2026, Ediția a 2-a?</h2>
            <p className="text-gray-600 mb-4">Start-Up Nation 2025 – 2026, Ediția a 2-a este un program cu fonduri europene și de la bugetul de stat, cu un buget total de 446 milioane EUR, lansat în 2024. Parcursul are două etape: mai întâi un curs obligatoriu de competențe antreprenoriale pentru persoane fizice, apoi o sesiune separată de finanțare pentru firmele înființate de absolvenți.</p>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-sm mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Sesiunea a doua de cursuri – octombrie 2026</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Înscrieri deschise pe minimis.imm.gov.ro</li>
              <li>Sesiunea rămâne deschisă 30 de zile, cu posibilitate de prelungire până la epuizarea locurilor</li>
              <li>17.600 de locuri la nivel național</li>
              <li>Cursul durează 40 de ore, online sau cu prezență fizică, în funcție de furnizor</li>
              <li>La final primești un certificat de absolvire acreditat de Ministerul Muncii, Familiei, Tineretului și Solidarității Sociale</li>
            </ul>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-sm mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Cine se poate înscrie?</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Tineri între 18 și 30 de ani neîmpliniți, din toată România</li>
              <li>Indiferent de statutul pe piața muncii, inclusiv persoanele reîntoarse în țară</li>
              <li>Absolvenți cel puțin ai învățământului gimnazial (ISCED 2)</li>
              <li>Persoanele declarate eligibile în prima sesiune care nu au absolvit cursul se pot reînscrie, actualizând cererea inițială</li>
            </ul>
            <p className="text-gray-600 mb-4">În această sesiune nu există locuri pentru categoriile din Pilonul II (persoane de 30-35 de ani, șomeri, persoane inactive, grupuri dezavantajate).</p>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-sm mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">După curs: finanțarea</h2>
            <p className="text-gray-600 mb-4">Cu certificatul de absolvire îți înființezi o firmă la ONRC. Firma poate aplica, într-o sesiune separată pentru persoane juridice, la un ajutor de minimis de până la 250.000 lei, care acoperă cel mult 90% din cheltuielile eligibile. Contribuția proprie este de minimum 10%.</p>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-sm mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Surse oficiale</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li><a className="text-blue-600" href="https://economie.gov.ro/start-up-nation-inscrierile-la-cursurile-gratuite-de-antreprenoriat-pentru-tinerii-sub-30-de-ani-incep-pe-6-octombrie/" target="_blank" rel="noopener noreferrer">Comunicarea MEDAT privind sesiunea a doua</a></li>
              <li><a className="text-blue-600" href="https://legislatie.just.ro/Public/DetaliiDocumentAfis/311591" target="_blank" rel="noopener noreferrer">Procedura de implementare a programului</a></li>
              <li><a className="text-blue-600" href="https://minimis.imm.gov.ro" target="_blank" rel="noopener noreferrer">Platforma de înscriere minimis.imm.gov.ro</a></li>
            </ul>
            <p className="text-gray-600 mb-4">aplica-startup.ro este un site independent de informare și sprijin, nu un site guvernamental.</p>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AboutProgramPage;